import { CLIENT } from '@/store/enums';
import type { Hue } from '@/types/styles';

// calendar timelines
export const HOUR_IN_PX = 54;
export const LINE_IN_PX = 1;
export const HALF_AN_HOUR_BLOCK_SPAN = HOUR_IN_PX / 2;
export const SIDEBAR_DELAY = 400;
export const MIN_WIDTH_SHIFT = 30;
export const MIN_WIDTH_WEEKDAY = 139;
export const PADDING_WEEKDAY = 3;
export const PADDING_SCHEDULE = 3;
export const SHIFTPICKUP_CART_HEADER_HEIGHT = 48;
export const SHIFTPICKUP_CART_TOP_SPACE = 23;
export const TIMELINE_COLUMN_WIDTH = 83;
export const TIMELINE_COLUMN_WIDTH_MOBILE = 53;
export const CALENDAR_MESSAGE_HEIGHT = 70;
export const CALENDAR_MESSAGE_HEIGHT_MOBILE = 120;
export const WEEKDAY_HEADER_HEIGHT = 143;
export const WEEKDAY_HEADER_HEIGHT_MOBILE = 90;
export const STICKY_SHADOW_HEIGHT_MOBILE = 70;

// range picker
export const OFFSET_MINUS = 5;
export const OFFSET_PLUS = 5;
export const SET_PREVIOUS_WEEK = -1;
export const SET_NEXT_WEEK = 1;
export const WEEKS_HORIZON = 4;

// time off
export const SET_PREVIOUS_START_DAY_INDEX = -1;
export const SET_NEXT_START_DAY_INDEX = 1;
export const DEFAULT_CONTRACT_COLOR: Hue = 'indigo';
export const MAX_TIME_OFFS_COUNT_THAT_FIT = 8;
export const DEFAULT_WEEKDAY_HEIGHT = 161;
export const TIME_OFF_STRIPE_HEIGHT = 14;
export const LABEL_MONTH_PICKER_HEIGHT = 330;

// blocks
export const BLOCK_DURATION = 30;
export const BLOCKS_IN_HOUR = 2;
export const BLOCKS_IN_DAY = 48;
export const BLOCKS_IN_WEEK = BLOCKS_IN_DAY * 7;
export const SECONDS_IN_BLOCK = 1800;
export const MILLIS_IN_BLOCK = SECONDS_IN_BLOCK * 1000;

// common
export const SCREEN_SIZE_MOBILE = 414;
export const SCREEN_SIZE_TABLET = 640;
export const SCREEN_SIZE_LAPTOP = 1014;
export const SCREEN_SIZE_DESKTOP = 1280;
export const NAVBAR_HEIGHT = 77;
export const DEBOUNCE_RESIZE_OBSERVER_DELAY = 500;
export const DEBOUNCE_SEARCH_DELAY = 1000;
export const FULFILLED_ACTION = 'fulfilled';
export const PENDING_ACTION = 'pending';
export const REJECTED_ACTION = 'rejected';
export const UNIQUE_ADDRESS_LENGTH = 2;

// time
export const DAYS_IN_MONTH = 31;
export const DAYS_IN_WEEK = 7;

export const HOURS_IN_DAY = 24;

export const MINUTES_IN_HOUR = 60;

export const SECONDS_IN_MINUTE = 60;

export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_DAY = 86400;

export const MILLIS_IN_SECOND = 1000;
export const MILLIS_IN_WEEK = DAYS_IN_WEEK * HOURS_IN_DAY * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * MILLIS_IN_SECOND;
export const MILLIS_IN_MONTH = DAYS_IN_MONTH * HOURS_IN_DAY * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * MILLIS_IN_SECOND;

// error codes
export const INVALID_SHIPPING_ADDRESS_ERROR_CODE = 816;

// z-index
export const Z_INDEX_ACCORDION_HEADER_SLOT = 1;
export const Z_INDEX_WEEKDAY_HEADER = 5;
export const Z_INDEX_WEEKDAY_HEADER_AFTER = 1;
export const Z_INDEX_TIMELINE_COLUMN = 6;
export const Z_INDEX_TIMELINE_COLUMN_SHADOW_COVER = 1;
export const Z_INDEX_TIMELINE_HOURS = 2;
export const Z_INDEX_CURRENT_TIME_INDICATOR = 1;
export const Z_INDEX_STICKY_SHADOW = 1;
export const Z_INDEX_STICKY_SHADOW_COVER = 2;
export const Z_INDEX_STICKY_SHADOW_PLACEHOLDER = 3;
export const Z_INDEX_AVAILABILITY_COLUMN_STICKY_SHADOW_COVER = 4;
export const Z_INDEX_AVAILABILITY_COLUMN_SMALL_HEADER = 5;
export const Z_INDEX_AVAILABILITY_BASKET = 5;
export const Z_INDEX_SIDEBAR_TOGGLE = 7;
export const Z_INDEX_BACKDROP = 8;
export const Z_INDEX_MODAL = 9;
export const Z_INDEX_NAV_DROPDOWN = 10;
export const Z_INDEX_FULLSCREEN_LOADER = 200;
export const Z_INDEX_BOTTOM_DRAWER = 100;
export const Z_INDEX_SIDEBAR = 9;
export const Z_INDEX_CALENDAR_LEGEND = 7;
export const Z_INDEX_SHIFT_ROW = 1;

// to get the access token from oidc user
export const OIDC_USER = 'OidcUser';

// date time
export const YEAR_MONTH_DAY_TIME = 'yyyy/MM/dd hh:mm';
export const ISO_STRING = 'yyyy-MM-ddTHH:mm:ss.sss';
export const MONTH_DAY_YEAR_FORMAT = 'MMM d, yyyy';
export const MONTH_FULL_DAY_YEAR_FORMAT = 'MMM dd, yyyy';
export const MONTH_DAY_HOUR_FORMAT = 'MMM d, hh:mm aaa';
export const FULL_MONTH_DAY_YEAR_FORMAT = 'MMMM d, yyyy';
export const YEAR_MONTH_DAY_TIME_FORMAT = 'yyyy-MM-dd hh:mm:ss aaaa';
export const MONTH_DATE_YEAR = 'MM-dd-yyyy';
export const MONTH_DAY_YEAR_MILITARY_DATETIME = 'MM/dd/yyyy HH:mm:ss';
export const MONTH_DAY_YEAR_DATETIME_AM_PM_FORMAT = 'MM/dd/yyyy HH:mmaaa';
export const MONTH_DAY_YEAR_DATETIME_12HOUR_AM_PM_FORMAT = 'MM/dd/yyyy hh:mmaaa';
export const MONTH_DAY_YEAR_HOUR_MIN_FORMAT = 'MMM dd, yyyy hh:mm aaa';
export const MONTH_DAY_YEAR_DEF_FORMAT = 'MM/dd/yyyy';
export const YEAR_MONTH_DAY_FORMAT = 'yyyy/MM/dd';
export const YEAR_MONTH_DAY_DASH_FORMAT = 'yyyy-MM-dd';
export const HOUR_AM_PM_FORMAT = 'haaa';
export const MONTH_DAY_FORMAT = 'LLL dd';
export const DAY_MONTH_YEAR_DOTTED_FORMAT = 'dd.MM.yyyy';
export const DAY_FORMAT = 'dd';
export const FULL_MONTH_DAY_FORMAT = 'LLLL dd';
export const AM_PM_TIME_FORMAT = 'hh:mmaaa';
export const AM_PM_TIME_SPACE_FORMAT = 'hh:mm aaa';
export const AM_PM_TIME_SPACE_UPPERCASE_FORMAT = 'hh:mm a';
export const AM_PM_TIME_SPACE_UPPERCASE_FORMAT_NO_LEADING_ZERO = 'h:mm a';
export const DAY_MONTH = 'd/M';
export const WEEK_DAY_SHORT = 'E';
export const WEEK_DAY_FULL = 'EEEE';
export const WEEK_DAY_MONTH_DAY = 'EEEE, LLL dd';
export const DATE_DOTTED = 'MMM.dd.yyyy';
export const MONTH_DAY_YEAR_HOUR_FORMAT = 'MMM d, y hh:mm aa';
export const MONTH_DAY_YEAR_HOUR_FORMAT_NBSP = 'MMM\u00A0d,\u00A0y hh:mm\u00A0aa';
export const MONTH_DAY_FULL_YEAR_HOUR_FORMAT = 'MMM d, yyyy hh:mm aaa';
export const WEEK_DAY_TIME_FORMAT = 'EEEE h:mm a';
export const SHORT_WEEKDAY_TIME = 'eee, hh:mm a';
export const DATE_ISO_FORMAT = 'yyyy-MM-dd';
export const TIME_ISO_FORMAT = 'HH:mm:ss';
export const FULL_WEEKDAY_MONTH_DAY_FORMAT = 'EEEE, MMMM d';
export const FULL_WEEKDAY_MONTH_YEAR_FORMAT = 'EEEE, MMMM yyyy';
export const FULL_WEEKDAY_MONTH_YEAR_DATE_FORMAT = 'EEEE, dd MMMM yyyy';
export const FULL_WEEKDAY_MONTH_YEAR_HOUR_DATE_FORMAT = 'EEEE, MMMM dd yyyy, h:mm:ss a';
export const AM_PM = 'aaa';
export const HOUR_MINUTES = 'h:mm';
export const MONTH_DAY_YEAR_DATETIME_12HOUR_AM_PM_FORMAT2 = "MM/dd/yyyy hh:mm:ss aaaaa'm'";

export const MAX_SCHEDULES_ACTIVE = 8;
export const MAX_CONTRACT_DETAILS_WIDGET_HEIGHT = 200;
export const MIN_AGE_REQUIREMENT = 31536000000;

// contracts
export const VALUE_TRUE = 'True';
export const VALUE_FALSE = 'False';
export const SEARCH_AGENT_DEBOUNCE_MS = 300;
export const NON_ACTIVE_AGENTS_DAY_OFFSET = 90;

// Dashboard
export const SCHEDULE_STATUS_DAYS_IN_PAST = 5;
export const SCHEDULE_STATUS_DAYS_IN_FUTURE = 4;
export const SCHEDULE_STATUS_MIN_MAX_HOURS = 8;

//Auth
export const LOGOUT_REDIRECT_TIME = 10000;

// Currency Ids
export const CURRENCY_ID_USD = 1;
export const CURRENCY_ID_CAD = 2;

// resources
export const NEW_RESOURCE_THRESHOLD = 2; // number of days since publication when the resource is considered new
export const PENDING_ALERT_THRESHHOLD = 24; // number of hours since publication when the alert is considered pending
export const ATTACHMENT_SIZE_LIMIT = 1.1e9; // ~1GB in bytes
export const SYSTEM_CLIENT_ID = 9000;
export const SYSTEM_CLIENT_NAME = 'LiveXchange';
export const RECORDS_TABLE_PAGE_SIZE = 50;
export const ID_COLUMN_NAME = 'Unique Id';

// class
export const EXTERNALID_CLIENTID_LIST = [CLIENT.TELEPERFORMANCE_TURBO_TAX];

export const CAMPAIGN_STATUS_ID = {
  PENDING: 1,
  LIVE: 2,
  WAITLIST: 3,
  EXPIRED: 4,
};
export const CAMPAIGN_STATUS_COLOR = {
  PENDING: '#E89943',
  LIVE: '#28A745',
  WAITLIST: '#7E8A96',
  EXPIRED: '#EB5757',
};
export const CLASS_STATUS_ID = {
  LIVE: 1,
  PAUSED: 2,
  COMPLETED: 3,
  CLOSED: 4,
};
export const CLASS_STATUS_COLOR = {
  LIVE: '#10B981',
  PAUSED: '#7E8A96',
  COMPLETED: '#008ACD',
  CLOSED: '#135188',
};
// regex
// src https://regexr.com/39nr7
export const URL_REGEX =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

// src https://stackoverflow.com/a/43931246
export const TIMESTAMP_ISO_REGEX =
  /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,9})?(?:Z|[+-][01]\d:[0-5]\d)?$/;

// src https://stackoverflow.com/a/28022901
export const TIMEZONE_ISO_REGEX = /(?:Z|[+-][01]\d:[0-5]\d)$/;

// attachment name validation
export const ATTACHMENT_NAME_REGEX = /[^a-z-\d ]/gi;

// attachment prefix matching
export const ATTACHMENT_PREFIX_REGEX = /DBF-\d+-\d+-C\d+-\d+-|\w+-\d+-\d+-/;

export const COMPUTER_TEST_INTERVAL = 20000;

export const INTERVAL_TIMEOUT = 120;

export const COMPUTER_TEST_INTERVAL_SECS = 10;

export enum NOTE_STATUS {
  CREATE = 'create',
  UPDATE = 'update',
  READ = 'read',
  DELETE = 'delete',
  DISABLED = 'disabled',
}

// external links URL
export const LEARN_URL = 'https://learn.livexconnect.com/local/gigcxlogin/autologin.php';
export const REFER_A_FRIEND_VIDEO_URL = 'https://www.youtube.com/embed/2kutkN9yL94?si=UORTxhoFN9Cu8nfF';
export const VOICE_GUIDE_VIDEO_URL = 'https://www.youtube.com/embed/pmODa2JIXJk?si=nIZ8FKRM5sLDzf6W';
export const THANK_YOU_PAGE_VIDEO_URL = 'https://www.youtube.com/embed/TOOgkbaW5Is?si=n-gk1qlmJBaVi-UW';
export const PAY_SHARK_URL = 'https://prod.payshark.com/';
export const PAY_SHARK_SET_UP_URL = 'https://payshark.com/';
export const BANNER_VIDEO_URL = 'https://www.youtube.com/embed/VU7mQ9g9Z_I';

// API
export const API_BASE_URL = '/api/v3';

//Interview
export const MINUTES_ENABLE_INTERVIEW = 5;

// Recovery flags
export const ENABLE_EMAIL = false;

export const ERROR_MESSAGE_CLOSE_MILLISECONDS = 10000;

export const MARK_ATTENDANCE_FAILURE_STATUS_CODE = 400;

export const FETCH_CLASS_DETAILS_INTERVAL = 15000;
